(() => {
  const normalizeText = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const isValidValue = (val) => {
    if (val == null) return false;
    const str = String(val).trim();
    return str.length > 0 && !/^[-–—\s]+$/.test(str);
  };

  const splitMeasurements = (value) => {
    const parts = String(value || '')
      .split('/')
      .map((part) => part.trim())
      .filter((part) => isValidValue(part));
    return parts.length > 1 ? parts : [String(value || '').trim()];
  };

  const iconSvgs = {
    'seat height': '▬',
    'armrest height': '⌂',
    'backrest height': '▥',
    'back height': '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="2"/><line x1="9" y1="4" x2="9" y2="20"/><line x1="12" y1="4" x2="12" y2="20"/><line x1="15" y1="4" x2="15" y2="20"/></svg>',
    'seat depth': '▭',
    'seat width': '⬡',
    length: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8L22 12L18 16"/><path d="M6 8L2 12L6 16"/><path d="M2 12H22"/></svg>',
    depth: '↕',
    height: '↨'
  };

  const getIconElement = (title = '', customIcon = '') => {
    const iconContainer = document.createElement('div');
    iconContainer.className = 'bh-dimensions__icon';
    iconContainer.setAttribute('aria-hidden', 'true');

    if (customIcon) {
      const trimmed = String(customIcon).trim();
      if (trimmed.startsWith('http') || trimmed.startsWith('/') || trimmed.includes('.')) {
        const img = document.createElement('img');
        img.src = trimmed;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 22;
        img.height = 22;
        iconContainer.append(img);
        return iconContainer;
      }
    }

    const titleKey = normalizeText(title);
    for (const [key, svg] of Object.entries(iconSvgs)) {
      if (titleKey.includes(key)) {
        iconContainer.innerHTML = svg;
        return iconContainer;
      }
    }

    if (customIcon) {
      iconContainer.textContent = customIcon;
    } else {
      iconContainer.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/></svg>';
    }
    return iconContainer;
  };

  const createValueBlock = (values = [], rowTitle = '') => {
    const valueWrapper = document.createElement('div');
    valueWrapper.className = 'bh-dimensions__value';

    const validValues = values.filter((v) => v && isValidValue(v.value));
    if (!validValues.length) return valueWrapper;

    const hasLabels = validValues.some((v) => v.label && String(v.label).trim());

    if (validValues.length === 1 && !hasLabels) {
      const single = document.createElement('div');
      single.className = 'bh-dimensions__single-value';
      const num = document.createElement('span');
      num.className = 'bh-dimensions__number';
      num.textContent = validValues[0].value;
      single.append(num);
      valueWrapper.append(single);
      return valueWrapper;
    }

    const multi = document.createElement('div');
    multi.className = 'bh-dimensions__multi-values';

    const rowTitleLower = normalizeText(rowTitle);

    validValues.forEach((item, index) => {
      if (index > 0) {
        const sep = document.createElement('span');
        sep.className = 'bh-dimensions__multi-sep';
        const isHeight = rowTitleLower.includes('height') && !rowTitleLower.includes('seat') && !rowTitleLower.includes('arm') && !rowTitleLower.includes('back');
        const isHeadrest = item.label && normalizeText(item.label).includes('headrest');
        sep.innerHTML = (isHeight || isHeadrest) ? '&rarr;' : '-';
        multi.append(sep);
      }

      const col = document.createElement('div');
      col.className = 'bh-dimensions__multi-col';

      if (item.label) {
        const lbl = document.createElement('span');
        lbl.className = 'bh-dimensions__multi-label';
        lbl.textContent = item.label;
        col.append(lbl);
      }

      const num = document.createElement('span');
      num.className = 'bh-dimensions__multi-number';
      const isAccent = (item.label && normalizeText(item.label).includes('headrest')) ||
        (rowTitleLower.includes('height') && !rowTitleLower.includes('seat') && !rowTitleLower.includes('arm') && !rowTitleLower.includes('back') && index === 1);
      if (isAccent) {
        num.classList.add('bh-dimensions__multi-number--accent');
      }
      num.textContent = item.value;
      col.append(num);

      multi.append(col);
    });

    valueWrapper.append(multi);
    return valueWrapper;
  };

  const createDimensionRow = ({ title, subtitle, icon, values }) => {
    const row = document.createElement('div');
    row.className = 'bh-dimensions__row bh-dimensions__custom-row';

    const iconEl = getIconElement(title, icon);

    const labelGroup = document.createElement('div');
    labelGroup.className = 'bh-dimensions__label-group';
    const label = document.createElement('div');
    label.className = 'bh-dimensions__label';
    label.textContent = title;
    labelGroup.append(label);

    if (subtitle) {
      const note = document.createElement('div');
      note.className = 'bh-dimensions__note';
      note.textContent = subtitle;
      labelGroup.append(note);
    }

    const valueEl = createValueBlock(values, title);
    row.append(iconEl, labelGroup, valueEl);
    return row;
  };

  const createSummaryBox = (label, sublabel, value) => {
    const box = document.createElement('div');
    box.className = 'bh-dimensions__summary';

    const info = document.createElement('div');
    info.className = 'bh-dimensions__summary-info';
    const title = document.createElement('div');
    title.className = 'bh-dimensions__summary-title';
    title.textContent = label || 'SLEEPING AREA';
    info.append(title);

    if (sublabel) {
      const sub = document.createElement('div');
      sub.className = 'bh-dimensions__summary-sub';
      sub.textContent = sublabel;
      info.append(sub);
    }

    const formattedVal = String(value || '')
      .replace(/[xX*]/g, ' × ')
      .replace(/\s+/g, ' ')
      .trim();

    const valEl = document.createElement('div');
    valEl.className = 'bh-dimensions__summary-value';
    valEl.textContent = formattedVal;

    box.append(info, valEl);
    return box;
  };

  const renderCustomJsonRows = (root) => {
    const source = root.querySelector('.bh-dimensions__custom-data');
    const container = root.querySelector('[data-dimension-custom-rows]');
    if (!source || !container) return false;

    try {
      const customRows = JSON.parse(source.content.textContent.trim());
      if (!Array.isArray(customRows) || !customRows.length) return false;

      const renderedRows = customRows.map((data) => {
        if (!data || typeof data !== 'object') return null;
        const values = Array.isArray(data.values)
          ? data.values
          : data.value != null
          ? [{ label: data.valueLabel || '', value: data.value }]
          : [];
        const availableValues = values.filter((item) => item && isValidValue(item.value));
        if (!availableValues.length) return null;

        return createDimensionRow({
          title: String(data.label || data.title || ''),
          subtitle: String(data.note || data.subtitle || ''),
          icon: String(data.icon || ''),
          values: availableValues
        });
      }).filter(Boolean);

      if (renderedRows.length) {
        container.replaceChildren(...renderedRows);
        return true;
      }
    } catch (e) {
      // ignore JSON errors
    }
    return false;
  };

  // const parseTableDescription = (root) => {
  //   const descriptionTemplate = root.querySelector('.bh-dimensions__description-source');
  //   const container = root.querySelector('[data-dimension-custom-rows]');
  //   const summaryContainer = root.querySelector('[data-dimension-summary]');
  //   if (!descriptionTemplate || !container) return;

  //   // If server already rendered metaobject or editor rows, don't overwrite rows
  //   const hasServerRows = Boolean(root.querySelector('.bh-dimensions__rows > [data-dimension-row]:not([hidden])'));
  //   const hasServerSummary = Boolean(summaryContainer && summaryContainer.children.length > 0);

  //   const parsedDescription = new DOMParser().parseFromString(descriptionTemplate.innerHTML, 'text/html');
  //   const tables = parsedDescription.querySelectorAll('table');
  //   if (!tables.length) return;

  //   let tableRowsGenerated = false;

  //   tables.forEach((table) => {
  //     const rows = Array.from(table.rows);
  //     if (!rows.length) return;

  //     const headerRowIndex = rows.findIndex((row) => {
  //       const labels = Array.from(row.cells).map((cell) => normalizeText(cell.textContent));
  //       return labels.some((l) => /^(length|width|size|model)$/i.test(l)) &&
  //         labels.some((l) => /depth|height/i.test(l));
  //     });

  //     if (headerRowIndex < 0) return;

  //     const headerRow = rows[headerRowIndex];
  //     const headers = Array.from(headerRow.cells).map((cell) => normalizeText(cell.textContent));

  //     // Find first valid data row
  //     const dataRow = rows.slice(headerRowIndex + 1).find((row) => {
  //       const cells = Array.from(row.cells);
  //       return cells.some((c) => isValidValue(c.textContent));
  //     });

  //     if (!dataRow) return;

  //     const cells = Array.from(dataRow.cells).map((cell) => cell.textContent.trim());

  //     const getColVal = (regex) => {
  //       const idx = headers.findIndex((h) => regex.test(h));
  //       if (idx >= 0 && isValidValue(cells[idx])) return cells[idx];
  //       return '';
  //     };

  //     // If we don't have server-rendered rows, build the rows from table
  //     if (!hasServerRows) {
  //       const rowsToAdd = [];

  //       // 1. WIDTH (Length 1, Length 2, Length 3)
  //       const l1 = getColVal(/^length\s*1$/);
  //       const l2 = getColVal(/^length\s*2$/);
  //       const l3 = getColVal(/^length\s*3$/);
  //       const genericWidth = getColVal(/^(width|length)$/);

  //       const widthValues = [];
  //       if (l1) widthValues.push({ label: (l2 || l3) ? 'L1' : '', value: l1 });
  //       if (l2) widthValues.push({ label: 'L2', value: l2 });
  //       if (l3) widthValues.push({ label: 'L3', value: l3 });
  //       if (!widthValues.length && genericWidth) {
  //         const splitW = splitMeasurements(genericWidth);
  //         splitW.forEach((val, i) => widthValues.push({ label: splitW.length > 1 ? `L${i + 1}` : '', value: val }));
  //       }

  //       if (widthValues.length) {
  //         rowsToAdd.push(createDimensionRow({
  //           title: root.dataset.widthLabel || 'WIDTH',
  //           subtitle: widthValues.length > 1 ? (root.dataset.widthNote || 'Corner / U-shape layout') : root.dataset.widthNote || '',
  //           values: widthValues
  //         }));
  //       }

  //       // 2. DEPTH
  //       const depthVal = getColVal(/^depth$/);
  //       if (depthVal) {
  //         const depthParts = splitMeasurements(depthVal);
  //         const depthValues = depthParts.length > 1
  //           ? [{ label: 'Upright', value: depthParts[0] }, { label: 'Reclined', value: depthParts[1] }]
  //           : [{ label: '', value: depthParts[0] }];

  //         rowsToAdd.push(createDimensionRow({
  //           title: root.dataset.depthLabel || 'DEPTH',
  //           subtitle: root.dataset.depthNote || '',
  //           values: depthValues
  //         }));
  //       }

  //       // 3. HEIGHT
  //       const heightVal = getColVal(/^height$/);
  //       if (heightVal) {
  //         const heightParts = splitMeasurements(heightVal);
  //         const heightValues = heightParts.length > 1
  //           ? [{ label: 'Back', value: heightParts[0] }, { label: 'Headrest', value: heightParts[1] }]
  //           : [{ label: '', value: heightParts[0] }];

  //         rowsToAdd.push(createDimensionRow({
  //           title: root.dataset.heightLabel || 'HEIGHT',
  //           subtitle: root.dataset.heightNote || '',
  //           values: heightValues
  //         }));
  //       }

  //       // 4. SEAT HEIGHT
  //       const seatHeightVal = getColVal(/seat\s*height/);
  //       if (seatHeightVal) {
  //         rowsToAdd.push(createDimensionRow({
  //           title: 'SEAT HEIGHT',
  //           subtitle: 'Floor to seat cushion',
  //           values: [{ label: '', value: seatHeightVal }]
  //         }));
  //       }

  //       // 5. ARMREST HEIGHT
  //       const armrestVal = getColVal(/armrest\s*height/);
  //       if (armrestVal) {
  //         rowsToAdd.push(createDimensionRow({
  //           title: 'ARMREST HEIGHT',
  //           subtitle: 'Floor to armrest top',
  //           values: [{ label: '', value: armrestVal }]
  //         }));
  //       }

  //       // 6. BACKREST HEIGHT
  //       const backrestVal = getColVal(/back(rest)?\s*height/);
  //       if (backrestVal) {
  //         rowsToAdd.push(createDimensionRow({
  //           title: 'BACKREST HEIGHT',
  //           subtitle: '',
  //           values: [{ label: '', value: backrestVal }]
  //         }));
  //       }

  //       // 7. SEAT DEPTH
  //       const seatDepthVal = getColVal(/seat\s*depth/);
  //       if (seatDepthVal) {
  //         rowsToAdd.push(createDimensionRow({
  //           title: 'SEAT DEPTH',
  //           subtitle: '',
  //           values: [{ label: '', value: seatDepthVal }]
  //         }));
  //       }

  //       // 8. SEAT WIDTH
  //       const seatWidthVal = getColVal(/seat\s*width/);
  //       if (seatWidthVal) {
  //         rowsToAdd.push(createDimensionRow({
  //           title: 'SEAT WIDTH',
  //           subtitle: '',
  //           values: [{ label: '', value: seatWidthVal }]
  //         }));
  //       }

  //       if (rowsToAdd.length) {
  //         container.replaceChildren(...rowsToAdd);
  //         tableRowsGenerated = true;
  //       }
  //     }

  //     // Check Sleeping Area for Dimensions Summary
  //     if (!hasServerSummary && summaryContainer) {
  //       const sleepVal = getColVal(/sleeping\s*area/);
  //       if (sleepVal) {
  //         summaryContainer.replaceChildren(createSummaryBox(
  //           root.dataset.sleepLabel || 'SLEEPING AREA',
  //           root.dataset.sleepNote || 'When converted to bed',
  //           sleepVal
  //         ));
  //       }
  //     }
  //   });

  //   return tableRowsGenerated;
  // };

  const updateCardVisibility = (root) => {
    const card = root.querySelector('[data-dimension-card]');
    if (!card) return;

    const hasRows = Boolean(root.querySelector('.bh-dimensions__row:not([hidden])'));
    const hasSummary = Boolean(root.querySelector('.bh-dimensions__summary'));
    const hasTags = Boolean(root.querySelector('.bh-dimensions__tags')?.children.length);

    const hasContent = hasRows || hasSummary;
    card.hidden = !hasContent;
    root.hidden = !hasContent && !hasTags;
  };

  const initializeDimensions = (scope = document) => {
    scope.querySelectorAll('.bh-dimensions:not([data-dimensions-ready])').forEach((root) => {
      root.dataset.dimensionsReady = 'true';
      // const hasJson = renderCustomJsonRows(root);
      // if (!hasJson) {
      //   parseTableDescription(root);
      // }
      renderCustomJsonRows(root);
      updateCardVisibility(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeDimensions());
  } else {
    initializeDimensions();
  }

  document.addEventListener('shopify:section:load', (event) => initializeDimensions(event.target));
})();